/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { MessageResponse } from '../models/MessageResponse';
import type { UpdateAgentProfileDto } from '../models/UpdateAgentProfileDto';
import type { UpdateClientProfileDto } from '../models/UpdateClientProfileDto';
import type { UpdateEmailDto } from '../models/UpdateEmailDto';
import type { UpdateSoProfileDto } from '../models/UpdateSoProfileDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UserResponse } from '../models/UserResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get current user profile
     * Returns the authenticated user with their role-specific profile data (client, agent, or society owner).
     * @returns UserResponse User profile retrieved successfully.
     * @throws ApiError
     */
    public usersControllerGetMe(): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/me',
            errors: {
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Update current user profile
     * Update the authenticated user basic profile fields (name, phone, country, avatar, birth date).
     * @returns UserResponse User profile updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateMe({
        requestBody,
    }: {
        requestBody: UpdateUserDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Change password
     * Change the current user password. Requires current password verification. Not available for Firebase-only accounts.
     * @returns MessageResponse Password changed successfully.
     * @throws ApiError
     */
    public usersControllerChangePassword({
        requestBody,
    }: {
        requestBody: ChangePasswordDto,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me/password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Firebase account or validation error.`,
                401: `Unauthorized.`,
                403: `Current password is incorrect.`,
            },
        });
    }
    /**
     * Update client profile
     * Update client-specific profile fields: wizzAlerte, sponsorshipCode, favoriteInstaller.
     * @returns UserResponse Client profile updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateClientProfile({
        requestBody,
    }: {
        requestBody: UpdateClientProfileDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me/client-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Only clients can update client profile.`,
                404: `User or client profile not found.`,
            },
        });
    }
    /**
     * Update agent profile
     * Update agent identity fields: firstName, lastName, email, phone, birthDate, avatar. Changes are saved to the AgentProfile table.
     * @returns UserResponse Agent profile updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateAgentProfile({
        requestBody,
    }: {
        requestBody: UpdateAgentProfileDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me/agent-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Only agents can update agent profile.`,
                404: `User or agent profile not found.`,
            },
        });
    }
    /**
     * Update society owner profile
     * Update society owner-specific profile fields: address, birthCity, nationality.
     * @returns UserResponse Society owner profile updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateSoProfile({
        requestBody,
    }: {
        requestBody: UpdateSoProfileDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me/so-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Only society owners can update society owner profile.`,
                404: `User or society owner profile not found.`,
            },
        });
    }
    /**
     * Update email
     * Update the authenticated user email address. Validates format and checks uniqueness.
     * @returns UserResponse Email updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateEmail({
        requestBody,
    }: {
        requestBody: UpdateEmailDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/me/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or email already in use.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Delete own account
     * Delete the authenticated user account and all associated data. Admin accounts cannot be deleted.
     * @returns MessageResponse Account deleted successfully.
     * @throws ApiError
     */
    public usersControllerDeleteAccount(): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/users/me/account',
            errors: {
                401: `Unauthorized.`,
                403: `Admin accounts cannot be deleted.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Sign out
     * Sign out the authenticated user by invalidating the refresh token.
     * @returns MessageResponse Signed out successfully.
     * @throws ApiError
     */
    public usersControllerSignOut(): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/me/sign-out',
            errors: {
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Check if phone number exists
     * Check if any user with the given countryCode and phoneNumber already exists.
     * @returns any Phone existence check result.
     * @throws ApiError
     */
    public usersControllerPhoneExists({
        countryCode,
        phoneNumber,
    }: {
        /**
         * Country code (ISO 3166-1 alpha-2)
         */
        countryCode: string,
        /**
         * Phone number
         */
        phoneNumber: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/phone-exists',
            query: {
                'countryCode': countryCode,
                'phoneNumber': phoneNumber,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * List all users (Admin)
     * Returns a paginated list of all users. Requires ADMIN role. Supports filtering by role, search, email verification status, and demo account flag.
     * @returns any List of users returned successfully.
     * @throws ApiError
     */
    public usersControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        role,
        search,
        emailVerified,
        demoAccount,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by user role
         */
        role?: 'CLIENT' | 'AGENT' | 'SOCIETY_OWNER' | 'ADMIN' | 'MUNICIPALITY',
        /**
         * Search by name or email
         */
        search?: string,
        /**
         * Filter by email verification status
         */
        emailVerified?: 'PENDING' | 'VALIDATED' | 'DENIED' | 'NOT_UPLOADED',
        /**
         * Filter by demo accounts
         */
        demoAccount?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'role': role,
                'search': search,
                'emailVerified': emailVerified,
                'demoAccount': demoAccount,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get user by ID (Admin)
     * Returns a single user with their role-specific profile. Requires ADMIN role.
     * @returns UserResponse User found.
     * @throws ApiError
     */
    public usersControllerFindOne({
        id,
    }: {
        /**
         * User unique identifier
         */
        id: string,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Update any user (Admin)
     * Admin endpoint to update any user basic profile fields. Requires ADMIN role.
     * @returns UserResponse User updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * User unique identifier
         */
        id: string,
        requestBody: UpdateUserDto,
    }): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Delete user (Admin)
     * Delete a user and all associated data (cascade delete). Requires ADMIN role.
     * @returns MessageResponse User deleted successfully.
     * @throws ApiError
     */
    public usersControllerRemove({
        id,
    }: {
        /**
         * User unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `User not found.`,
            },
        });
    }
}
